import type { StepForm } from '@types'
import type { FieldValues, UseFormUnregister } from 'react-hook-form'

interface Params {
  initialData: StepForm
  usedData: StepForm
  unregister: UseFormUnregister<FieldValues>
}

export function unregisterUnusedFields({ initialData, usedData, unregister }: Params) {
  const usedFields = usedData.map((question) => question.db_field_name)
  const unusedFields = initialData
    .filter((question) => !usedFields.includes(question.db_field_name))
    .map((question) => question.db_field_name)

  if (unusedFields.length) {
    unregister(unusedFields)
  }
}
